import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CoreComponent } from './core.component';
import { FacturaHomeComponent } from '../pages/factura/factura-home/factura-home.component';
import { FacturaDetalleComponent } from '../pages/factura/factura-detalle/factura-detalle.component';
import { FacturaCoreComponent } from '../pages/factura/factura-core/factura-core.component';
import { BadRequestComponent } from '../shared/bad-request/bad-request.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  {
    path: '',
    component: CoreComponent,     
    children: [
      {
        path: 'home',
        component: FacturaCoreComponent,
        data: { breadcrumb: 'Gestión de Facturas' },
        children: [
          {
            path: '',
            component: FacturaHomeComponent        
          },
          {
            path: 'detalle/:numero',
            component: FacturaDetalleComponent,
            data: { breadcrumb: 'Detalle' }
          }
        ],        
        canActivate: [MsalGuard]
      },
      {
        path: 'error',
        component: BadRequestComponent,
      },
    ]
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'error',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
